export const diagnosisItems = [
  {
    field: "qrisk3",
    id: "QRISK_GTE_20",
    name: "QRISK 3>=20%",
  },
  {
    field: "hypertenstionStage1NoTargetOrganDamage",
    id: "HYPERTENSION_STAGE_1_NO_TARGET_ORGAN_DAMAGE",
    name: "Hypertension Stage 1 (BP 140/90 to 155/99mmHg) with NO target organ damage",
  },
  {
    field: "hypertenstionStage1",
    id: "HYPERTENSION_STAGE_1_WITH_TARGET_ORGAN_DAMAGE",
    name: "Hypertension Stage 1 (BP 140/90 to 159/99mmHg) with target organ damage",
  },
  {
    field: "hypertenstionStage2",
    id: "HYPERTENSION_STAGE_2_OR_3",
    name: "Hypertension Stage 2 or 3 (BP>160/100mmHg)",
  },
  {
    field: "gestationalDiabetes",
    id: "GESTATIONAL_DIABETES",
    name: "Gestational Diabetes (if diagnosed since 1st January, 2023) All cardholders & Non GMS",
  },
  {
    field: "preEclampsia",
    id: "PRE_ECLAMPSIA",
    name: "Pre-eclampsia (if diagnosed since 1st January, 2023) All cardholders & Non GMS",
  },
  {
    field: "preDiabetes",
    id: "PRE_DIABETES",
    name: "Pre-Diabetes",
  },
  {
    field: "previousBNP",
    id: "PREVIOUS_HIGH_BNP",
    name: "Previous BNP greater or equal to 34 pg/ml or NT pro BNP greater or equal to 125 pg/ml, if previously recorded",
  },
];
